import React, { useState } from "react";
import axios from "axios";
import DisputesHeaderLight from "../Components/DisputesHeaderLight";
import { Container } from "react-bootstrap";
import * as Yup from "yup";
import { Input } from "../Components/Form/Form";
import Buttons from "../Components/Button/Buttons";

import { resetForm } from "../Functions/Utilities";
import { Formik, Form } from "formik";

import { useParams } from "react-router-dom";

const ResetPassword = () => {
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  const { token } = useParams();

  const handleSubmit = async (values) => {
    try {
      const response = await axios.post(
        `${window.__RUNTIME_CONFIG__.REACT_APP_API_URL}password-reset/${token}/`,
        values
      );

      setError(null);
      setSuccess(`${response.data["success"]}`);
    } catch (error) {
      if (error.response && error.response.data) {
        console.log(error);

        const data = error.response.data;

        if (typeof data === "string") {
          setError(data);
          setSuccess(null);
          return;
        }

        if (data.error) {
          setError(data.error);
          setSuccess(null);
          return;
        }

        Object.keys(data).forEach((field) => {
          let errorMessages = data[field];
          if (!Array.isArray(errorMessages)) {
            errorMessages = [errorMessages];
          }
          if (errorMessages && errorMessages.length > 0) {
            setError(errorMessages[0]);
            setSuccess(null);
          }
        });
      }
    }
  };

  return (
    <>
      <DisputesHeaderLight />
      <section className="py-[160px] overflow-hidden cover-background lg:py-[120px] md:py-[95px] sm:py-[80px] xs:py-[50px]">
        <Container>
          <div>
            <div className="text-[80px] mb-2 leading-[95px] text-[#ef8d23] font-bold uppercase tracking-[-7px] xl:tracking-[-4px] lg:text-[90px] md:text-[70px] md:leading-[65px] sm:text-[45px] sm:leading-[43px]">
              Reset Password
            </div>

            <div className="bg-lightgray p-16 lg:mt-[35px] md:p-10">
              <Formik
                initialValues={{ new_password: "", confirm_password: "" }}
                validationSchema={Yup.object().shape({
                  new_password: Yup.string()
                    .required("This field is required.")
                    .min(12, "Password must be minimum of 12 characters")
                    .matches(
                      /[A-Z]/,
                      "Password must contain at least one uppercase letter"
                    )
                    .matches(
                      /[a-z]/,
                      "Password must contain at least one lowercase letter"
                    )
                    .matches(/\d/, "Password must contain at least one number")
                    .matches(
                      /[!@#$%^&*]/,
                      "Password must contain at least one special character"
                    ),
                  confirm_password: Yup.string()
                    .required("This field is required.")
                    .oneOf(
                      [Yup.ref("new_password"), null],
                      "Passwords must match"
                    ),
                })}
                onSubmit={async (values, actions) => {
                  await new Promise((r) => handleSubmit(values));
                  resetForm(actions);
                }}
              >
                {({ isSubmitting, status }) => (
                  <Form>
                    {error && (
                      <div
                        className="mb-3 p-3 rounded text-danger"
                        style={{ border: "2px solid red" }}
                      >
                        {error}
                      </div>
                    )}
                    {success && (
                      <div
                        className="mb-3 p-3 rounded text-[#ef8d23]"
                        style={{ border: "2px solid #ef8d23" }}
                      >
                        {success}
                      </div>
                    )}
                    <Input
                      showErrorMsg={true}
                      name="new_password"
                      type="password"
                      labelClass="mb-[20px]"
                      label={
                        <div className="mb-[15px]">
                          New Password <span className="text-[#fb4f58]">*</span>
                        </div>
                      }
                      className="py-[13px] px-[15px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                      placeholder="Enter your new password"
                      data-test="new-password-input"
                    />
                    <Input
                      showErrorMsg={true}
                      name="confirm_password"
                      type="password"
                      labelClass="mb-[20px]"
                      label={
                        <div className="mb-[15px]">
                          Confirm Password{" "}
                          <span className="text-[#fb4f58]">*</span>
                        </div>
                      }
                      className="py-[13px] px-[15px] text-md leading-[initial] w-full border-[1px] border-solid border-[#dfdfdf]"
                      placeholder="Enter your new password again"
                      data-test="confirm-password-input"
                    />

                    <Buttons
                      ariaLabel="reset password"
                      type="submit"
                      className="btn-fill btn-fancy w-full font-medium font-serif rounded-none uppercase"
                      themeColor="#232323"
                      color="#fff"
                      size="md"
                      title="Reset Password"
                    />
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default ResetPassword;
